import React, { useEffect, useState } from "react";
import { useAuth } from "../../config/AuthContext";
import {
  Typography,
  Container,
  Card,
  CardContent,
  Paper,
  Button,
  Divider,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CommentForm from "./CommentForm";
import ReplyForm from "./ReplyForm";
import Replies from "./Replies";
import MarkdownPost from "./MarkdownPost";
import AppreciatePost from "./AppreciatePost";
import SharePost from "./SharePost";

const useStyles = makeStyles((theme) => ({
  postPagePost: {
    padding: theme.spacing(1),
    background: theme.palette.background.paper,
  },
  divider: {
    background: theme.palette.text.divider,
  },
  commentCard: {
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.palette.primary.dark}`,
    boxShadow: `7px 7px 2px ${theme.palette.primary.shadow}`,

    "& .MuiButton-root": {
      margin: theme.spacing(2, 0),
      background: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
  },
  commenterDetails: {
    color: theme.palette.text.secondary,
  },
  comment: {
    color: theme.palette.text.primary,
  },

  postPageLeftSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.default,
  },
  postPageRightSection: {
    padding: theme.spacing(1),
    background: theme.palette.background.default,
  },
}));

const PostPage = (props) => {
  const classes = useStyles();
  const { dbRef, currentUser } = useAuth();
  const [blogKey, setBlogKey] = useState(props.match.params.id);
  const [replyMode, setReplyMode] = useState(false);
  const [conversationId, setConversationId] = useState();
  const [commentsSnap, setCommentsSnap] = useState([]);
  let comments = [];

  useEffect(() => {
    setBlogKey(props.match.params.id);
  }, [props.match.params.id]);

  useEffect(() => {
    const unsubscribe = dbRef
      .child(`blogs/${blogKey}/BlogComments`)
      .on("value", (snapshot) => {
        setCommentsSnap(snapshot);
      });

    return unsubscribe;
  }, [blogKey, dbRef]);

  commentsSnap.forEach((child) => {
    comments.push(child);
  });

  const handleReplyMode = (index) => {
    setReplyMode(true);
    setConversationId(index);
  };

  const commentList = comments.map((comment, index) => {
    return (
      <Card className={classes.commentCard} key={index}>
        <CardContent>
          <Typography variant="subtitle1" className={classes.commenterDetails}>
            {comment.val().Commenter} [{comment.val().CommentDate}]
          </Typography>

          <Typography variant="subtitle1" paragraph className={classes.comment}>
            {comment.val().Comment}
          </Typography>
          <Replies commentKey={comment.key} blogKey={blogKey} />

          {currentUser && (
            <Button
              variant="contained"
              disabled={replyMode && conversationId === index}
              onClick={() => handleReplyMode(index)}
              disableElevation
            >
              Start Conversation
            </Button>
          )}

          {replyMode && conversationId === index && (
            <ReplyForm
              commentKey={comment.key}
              blogKey={blogKey}
              setReplyMode={setReplyMode}
            />
          )}
        </CardContent>
      </Card>
    );
  });
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.postPageLeftSection}
      ></Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={8}
        className={classes.postPageMiddleSection}
      >
        <Paper elevation={0} className={classes.postPagePost}>
          <MarkdownPost blogKey={blogKey} />
          <AppreciatePost blogKey={blogKey} />
          <Divider className={classes.divider} />
          <SharePost blogKey={blogKey} />
          <Container>
            <CommentForm blogKey={blogKey} />
          </Container>
          <Container>{commentList}</Container>
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={2}
        className={classes.postPageRightSection}
      ></Grid>
    </Grid>
  );
};

export default PostPage;
